import { createSlice } from '@reduxjs/toolkit';
import { fetchDistricts, fetchDistrictsByProvince } from '../thunks';

interface IDistrict {
  id: string;
  name: string;
  electoralDistrictId: number;
}

interface DistrictState {
  allDistricts: IDistrict[];
  districtsByProvince: IDistrict[];
  count: number;
  pages: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  allDistricts: [],
  districtsByProvince: [],
  count: 0,
  pages: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null
};

const districtSlice = createSlice({
  name: 'districts',
  initialState,
  reducers: {
    resetDistricts: (state) => {
      state.districtsByProvince = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistricts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.loading = false;
        state.allDistricts = action.payload.items;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchDistricts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch districts';
      })
      .addCase(fetchDistrictsByProvince.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistrictsByProvince.fulfilled, (state, action) => {
        state.loading = false;
        state.districtsByProvince = action.payload;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchDistrictsByProvince.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch districts by province';
      });
  }
});

export const { resetDistricts } = districtSlice.actions;
export const districtReducer = districtSlice.reducer;
